import React, { useState } from 'react';
import style from './statusProfile.module.css';
import { updateStatusThunk } from '../../../../../../../redux/reducers/profile-reducer';
import { useDispatch, useSelector } from 'react-redux';
import useIsOwner from '../../../../../../../customHooks/useIsOwner';

const StatusProfile = (props) => {
    const userStatus = useSelector((state) => state.profilePage.userInfo.status);
    const isOwner = useIsOwner();

    const [editMode, setEdit] = useState(false);
    const [statusText, setStatusText] = useState(userStatus);
    const dispatch = useDispatch();

    const editStatus = () => {
        if (!isOwner) {
            return;
        }
        setEdit((editMode) => editMode = true);
    };

    const setStatus = (event) => {
        setEdit((editMode) => editMode = false);
        dispatch(updateStatusThunk({ statusText }));
    };

    const updateStatus = (event) => {
        setStatusText((text) => text = event.target.value);
    };

    return (
        <div className={style.statusBlock}>
            {!editMode
                ? <p onDoubleClick={editStatus}>Status: {userStatus}</p>
                : <form className={style.editBlock} onBlur={setStatus}>
                    <input autoFocus={true} onChange={updateStatus} value={statusText} />
                </form>}
        </div>
    )
};

export default StatusProfile;